import { createActions } from '~/store/utils';

const { Types, Actions } = createActions({
  REGISTRATION_REQUEST: null,
  REGISTRATION_SUCCESS: null,
  REGISTRATION_FAILURE: null,
  REGISTRATION_ERROR: null,
  REGISTRATION_CLEAR: null,
  CONFIRM_EMAIL_REQUEST: null,
  CONFIRM_EMAIL_SUCCESS: null,
  CONFIRM_EMAIL_FAILURE: null,
  CONFIRM_EMAIL_ERROR: null,
  CONFIRM_EMAIL_CLEAR: null,
});

export { Actions, Types };
